// extracted by css-extract-rspack-plugin
export default {"actionListOverrides":"RelationshipsSection-module__actionListOverrides__t71Ki","groupHeading":"RelationshipsSection-module__groupHeading__WoWBT"};